module.exports = __webpack_public_path__ + "img/icon-attachments.86144f3b.svg";